import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";

import EmptyAchievementsFigure from "../../../../assets/images/empty-entity-achievements.png";

export const EmptyAchievements = () => {
  const { t } = useTranslation("profiles", { keyPrefix: "achievements" });

  return (
    <Box
      sx={{
        borderRadius: "8px",
        border: "1px solid #EAECF0",
        background: "#FFF",
        padding: "20px",
      }}
    >
      <Typography
        sx={{
          color: "var(--black-100, #1C1C1C)",
          fontFamily: "Montserrat",
          fontSize: "16px",
          fontStyle: "normal",
          fontWeight: 700,
          lineHeight: "24px",
        }}
      >
        {t("achievements")}
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "12px",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <img
          src={EmptyAchievementsFigure}
          alt="empty-achievements"
          style={{
            width: "73.51px",
            height: "73.483px",
          }}
        />
        <Typography
          sx={{
            color: "var(--Dark---1000, #111)",
            fontFamily: "Montserrat",
            fontSize: "14px",
            fontStyle: "normal",
            fontWeight: 500,
            lineHeight: "20px",
          }}
        >
          {t("noAchievements")}
        </Typography>
      </Box>
    </Box>
  );
};
